
import HeaderModal from '@components/new-styleguide/HeaderModal.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FilterOptions } from '@util/types';
import { today } from '@util/dates-and-times';
import DateInput from '@components/new-styleguide/form/DateInput.vue';
import PilotSelect from '@components/new-styleguide/form/PilotSelect.vue';
import TagSelect from '@components/new-styleguide/form/TagSelect.vue';
import ZoneSelect from '@components/new-styleguide/form/ZoneSelect.vue';
import { ZoneWithRules } from '@/models/SettingsModels';
import { Pilot, Tag, Zone } from '@/generated-clients/myTrips';

const SettingsModule = namespace('Settings');

@Component({
  name: 'TripsFilterModal',
  components: {
    HeaderModal,
    DateInput,
    PilotSelect,
    TagSelect,
    ZoneSelect
  },
})
export default class TripsFilterModal extends Vue {
  @SettingsModule.Getter('getTags')
  private tags: Tag[];

  @SettingsModule.Getter('getPilots')
  private pilots: Pilot[];

  @SettingsModule.Getter('getZones')
  private zones: ZoneWithRules[];

  @Prop(Object)
  private value: FilterOptions;

  @Prop({ default: false })
  private open: boolean;

  private filterOptions: FilterOptions = null;

  @Watch('open')
  private onOpenChanged(newOpen) {
    if (newOpen) { // reset original value
      this.filterOptions = this.value.copy();
    }
  }

  private created() {
    this.filterOptions = this.value.copy();
  }

  private submit() {
    if (this.filterOptions.errorsOnly) {
      this.filterOptions = this.filterOptions.asErrorsOnly();
    }
    this.$emit('submit', this.filterOptions);
    this.$emit('close')
  }

  get today() {
    return today()
  }

  get selectedTag() {
    return this.tags.find(tag => tag.id === this.filterOptions.tagId);
  }

  private handleTagInput(tag: Tag) {
    this.filterOptions.tagId = tag ? tag.id : null;
  }

  get selectedPilot() {
    return this.pilots.find(pilot => pilot.id === this.filterOptions.pilotId);
  }

  private handlePilotInput(pilot: Pilot) {
    this.filterOptions.pilotId = pilot ? pilot.id : null;
  }

  get selectedZone() {
    return this.zones.find(zone => zone.id === this.filterOptions.zoneId);
  }

  private handleZoneInput(zone: Zone) {
    this.filterOptions.zoneId = zone ? zone.id : null;
  }
}
